export default __webpack_public_path__ + "static/media/obs_step1.3e7ac8d1.png";